import { PageSize } from '../enums/page-size.enum';

export interface IPagination {
  page: number;
  size: PageSize;
}
